import en from './en.js';
import ja from './ja.js';
import ne from './ne.js';
import zh from './zh.js';
import ko from './ko.js';

const locales = { en, ja, ne, zh, ko };
export default locales;
